import { render, staticRenderFns } from "./report-class.vue?vue&type=template&id=510ded46&scoped=true&"
import script from "./report-class.vue?vue&type=script&lang=js&"
export * from "./report-class.vue?vue&type=script&lang=js&"
import style0 from "./report-class.vue?vue&type=style&index=0&id=510ded46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510ded46",
  null
  
)

export default component.exports